
import Vue from 'vue'
import BillingAddress from './BillingAddress.vue'
import SelectionAccordion, { SelectionAccordionOption } from '../SelectionAccordion.vue'

export default Vue.extend({
   name: 'OrderType',
   computed: {
      requiresShippingAddress(): boolean {
         return this.$store.getters.requiresShippingAddress
      },
      billingAddressType(): string {
         return this.$store.state.purchase.BillingAddressIsSameAsShippingAddress ? 'true' : 'false'
      },
      typeOptions(): SelectionAccordionOption[] {
         return [
            { name: 'Same as shipping address', value: 'true' },
            { name: 'Use a different billing address', value: 'false', component: BillingAddress },
         ]
      },
   },
   methods: {
      setOption(option: string) {
         this.$store.commit('setBillingAddressIsSameAsShippingAddress', option === 'true')
      },
   },
   components: {
      SelectionAccordion,
      BillingAddress,
   },
})
